export const COMMENT_MIN_LENGTH = 120;
export const MESSAGE_MIN_LENGTH = 300;
export const PITCH_MIN_LENGTH = 120;
export const AUTOMATED_RESPONSE_MAX_LENGTH = 300;
